import { TryOnGrid } from '@/components/try-on/TryOnGrid'

export function TabArchiveTryOn() {
    return <TryOnGrid archived={true} />
}
